import { registerPlugin } from '@capacitor/core';
const SunmiCardReader = registerPlugin('SunmiCardReader', {
    web: () => import('./web').then(m => new m.SunmiCardReaderWeb()),
});
export * from './definitions';
export { SunmiCardReader };
//# sourceMappingURL=index.js.map